{
  "loading": "Chargement...",
  "error": "Erreur",
  "cancel": "Annuler",
  "confirm": "Confirmer",
  "save": "Sauvegarder",
  "edit": "Modifier",
  "delete": "Supprimer",
  "deleting": "Suppression...",
  "create": "Créer",
  "update": "Mettre à jour",
  "search": "Rechercher",
  "filter": "Filtrer",
  "sort": "Trier",
  "export": "Exporter",
  "import": "Importer",
  "refresh": "Actualiser",
  "back": "Retour",
  "next": "Suivant",
  "previous": "Précédent",
  "close": "Fermer",
  "open": "Ouvrir",
  "view": "Voir",
  "download": "Télécharger",
  "upload": "Téléverser",
  "signOut": "Se déconnecter",
  "roles": {
    "practitioner": "Praticien",
    "institution": "Institution",
    "admin": "Administrateur",
    "unknown": "Inconnu"
  },
  "ui": {
    "avatar": "Avatar",
    "pagination": {
      "label": "pagination",
      "goToPrevious": "Aller à la page précédente",
      "goToNext": "Aller à la page suivante",
      "morePages": "Plus de pages"
    },
    "sidebar": {
      "title": "Barre latérale",
      "description": "Affiche la barre latérale mobile.",
      "toggle": "Basculer la barre latérale"
    },
    "breadcrumb": {
      "label": "fil d'Ariane",
      "more": "Plus"
    },
    "command": {
      "title": "Palette de commandes",
      "description": "Rechercher une commande à exécuter..."
    },
    "imageUpload": {
      "placeholder": "Cliquez pour télécharger une image",
      "invalidFile": "Fichier invalide",
      "preview": "Aperçu",
      "hint": "PNG, JPG, JPEG, WEBP (max 2 Mo)"
    },
    "markdownEditor": {
      "placeholder": "Rédigez votre contenu ici...",
      "loading": "Chargement de l'éditeur..."
    }
  },
  "mobileAppInfo": {
    "title": "Les évaluations se réalisent sur l'application mobile",
    "description": "Les évaluations se réalisent dans l'application mobile MetaDevProfile (téléphone ou tablette). L'espace web permet de consulter vos patients, résultats et ressources.",
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "notFound": {
    "title": "Page non trouvée",
    "description": "La page que vous cherchez n'existe pas.",
    "backToHome": "Retour à la page d'accueil"
  },
  "routeError": {
    "title": "Une erreur est survenue",
    "description": "Une erreur inattendue s'est produite. Veuillez réessayer.",
    "retry": "Réessayer"
  },
  "errors": {
    "unknownError": "Une erreur inconnue est survenue",
    "tryAgain": "Veuillez réessayer",
    "tryRefreshing": "Veuillez rafraîchir la page",
    "checkInfoAndRetry": "Veuillez vérifier vos informations et réessayer",
    "sendMessageFailed": "Échec de l'envoi du message",
    "sendFeedbackFailed": "Échec de l'envoi du commentaire"
  }
}
